module.exports = __webpack_public_path__ + "images/19132-INT8-945587e1b205e2fb5ff22648469f12bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Thumbnail_video/19132-INT8.jpg
// module id = 747
// module chunks = 0